module.exports = __webpack_public_path__ + "static/media/input.8210d1f7.svg";